// @ts-ignore
import momentTz from "moment-timezone/builds/moment-timezone-with-data-10-year-range.js";
import moment from "moment-timezone";

import pl from "./locales/pl";

momentTz.defineLocale("pl", pl);
momentTz.locale("pl");

export default momentTz as typeof moment;
